var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('schedule-post-view',{attrs:{"show":_vm.show,"post-data":_vm.postData},on:{"close":function($event){_vm.show = false},"save":_vm.onSave}})}
var staticRenderFns = []

export { render, staticRenderFns }